import actionTypes from "../common/actionTypes";
// constants
import { DATABASE_STATUTES } from "../common/constants";

const orderReducer = (state, action) => {
  switch (action.type) {
    // fetch orders
    case actionTypes.FETCH_ORDERS:
      return {
        ...state,
        statuses: {
          ...state.statuses,
          loadOrders: DATABASE_STATUTES.LOADING,
        },
      };

    case actionTypes.FETCH_ORDERS_NOTIFICATIONS:
      return {
        ...state,
        statuses: {
          ...state.statuses,
          loadOrderNotifications: DATABASE_STATUTES.LOADING,
        },
      };

    case actionTypes.FETCH_ORDERS_SUCCESS: {
      return {
        ...state,
        orders: {
          ...state.orders,
          data: [...action.payload.orders, ...state.orders.data.slice(action.payload.endIndex)],
        },
        statuses: {
          ...state.statuses,
          loadOrders: DATABASE_STATUTES.LOADED,
        },
      };
    }

    case actionTypes.FETCH_ORDERS_FAILURE:
      return {
        ...state,
        error: action.payload,
        statuses: {
          ...state.statuses,
          loadOrders: DATABASE_STATUTES.LOADED_ERROR,
        },
      };

    // fetch more orders
    case actionTypes.FETCH_MORE_ORDERS_SUCCESS:
      return {
        ...state,
        orders: {
          ...state.orders,
          data: [
            ...state.orders.data.slice(0, action.payload.startIndex),
            ...action.payload.orders,
            ...state.orders.data.slice(action.payload.endIndex),
          ],
        },
        statuses: {
          ...state.statuses,
          loadOrders: DATABASE_STATUTES.LOADED,
        },
      };

    case actionTypes.FETCH_MORE_ORDERS_FAILURE:
      return {
        ...state,
        error: action.payload,
        statuses: {
          ...state.statuses,
          loadOrders: DATABASE_STATUTES.LOADED_ERROR,
        },
      };

    // fetch order notifications
    case actionTypes.FETCH_ORDERS_NOTIFICATIONS_SUCCESS: {
      const allNotifications = [...state.notifications.data, ...action.payload.notifications];
      const uniqueNotifications = Array.from(new Map(allNotifications.map((item) => [item.id, item])).values());

      return {
        ...state,
        notifications: {
          ...state.notifications,
          data: uniqueNotifications,
        },
        statuses: {
          ...state.statuses,
          loadOrderNotifications: DATABASE_STATUTES.LOADED,
        },
      };
    }

    case actionTypes.FETCH_ORDERS_NOTIFICATIONS_FAILURE:
      return {
        ...state,
        error: action.payload,
        statuses: {
          ...state.statuses,
          loadOrderNotifications: DATABASE_STATUTES.LOADED_ERROR,
        },
      };

    //Save product images to store
    case actionTypes.SAVE_PRODUCT_IMGS:
      return {
        ...state,
        error: action.payload,
        productImgs: {
          ...state.productImgs,
          [action.payload.productId]: action.payload.imgSrc,
        },
      };

    // delete order
    case actionTypes.DELETE_ORDER:
      return {
        ...state,
        statuses: {
          ...state.statuses,
          loadOrders: DATABASE_STATUTES.LOADING,
        },
      };

    case actionTypes.DELETE_ORDER_SUCCESS:
      return {
        ...state,
        orders: {
          ...state.orders,
          data: state.orders.data.filter(({ id }) => id !== action.payload),
        },
        statuses: {
          ...state.statuses,
          loadOrders: DATABASE_STATUTES.LOADED,
        },
      };

    case actionTypes.DELETE_ORDER_FAILURE:
      return {
        ...state,
        error: action.payload,
        statuses: {
          ...state.statuses,
          loadOrders: DATABASE_STATUTES.LOADED_ERROR,
        },
      };

    case actionTypes.PROCESSING_PAYMENTS:
      return {
        ...state,
        processingPayments: true,
      };

    case actionTypes.PROCESSING_PAYMENTS_SUCCESS:
      return {
        ...state,
        processingPayments: false,
      };

    case actionTypes.PROCESSING_PAYMENTS_FAILURE:
      return {
        ...state,
        processingPayments: false,
        error: action.payload,
      };

    case actionTypes.SEARCH_ORDERS:
      return {
        ...state,
        orders: {
          ...state.orders,
          filtered: [],
        },
        statuses: {
          ...state.statuses,
          loadOrders: DATABASE_STATUTES.LOADING,
        },
      };

    case actionTypes.SEARCH_ORDERS_SUCCESS:
      return {
        ...state,
        orders: {
          ...state.orders,
          filtered: action.payload,
        },
        statuses: {
          ...state.statuses,
          loadOrders: DATABASE_STATUTES.LOADED,
        },
      };

    case actionTypes.SEARCH_ORDERS_FAILURE:
      return {
        ...state,
        statuses: {
          ...state.statuses,
          loadOrders: DATABASE_STATUTES.LOADED_ERROR,
        },
      };

    case actionTypes.SEARCH_ORDER_NOTIFICATIONS:
      return {
        ...state,
        notifications: {
          ...state.notifications,
          filtered: [],
        },
        statuses: {
          ...state.statuses,
          loadOrderNotifications: DATABASE_STATUTES.LOADING,
        },
      };

    case actionTypes.SEARCH_ORDER_NOTIFICATIONS_SUCCESS:
      return {
        ...state,
        notifications: {
          ...state.notifications,
          filtered: action.payload,
        },
        statuses: {
          ...state.statuses,
          loadOrderNotifications: DATABASE_STATUTES.LOADED,
        },
      };

    case actionTypes.SEARCH_ORDER_NOTIFICATIONS_FAILURE:
      return {
        ...state,
        statuses: {
          ...state.statuses,
          loadOrderNotifications: DATABASE_STATUTES.LOADED_ERROR,
        },
      };
    // productEmails

    case actionTypes.FIRESTORE_ORDER_EMAILS:
      return {
        ...state,
        statuses: {
          ...state.statuses,
          loadOrderEmails: DATABASE_STATUTES.LOADING,
        },
      };

    case actionTypes.FIRESTORE_ORDER_EMAILS_SUCCESS:
      return {
        ...state,
        orderEmails: {
          data: [...action.payload.emailsHistory],
        },
        statuses: {
          ...state.statuses,
          loadOrderEmails: DATABASE_STATUTES.LOADED,
        },
      };

    case actionTypes.FIRESTORE_ORDER_EMAILS_FAILURE:
      return {
        ...state,
        error: action.payload,
        statuses: {
          ...state.statuses,
          loadOrderEmails: DATABASE_STATUTES.LOADED_ERROR,
        },
      };

    // pagination orders
    case actionTypes.FIRESTORE_SET_TOTAL_ORDERS_COUNT:
      return {
        ...state,
        pagination: {
          ...state.pagination,
          allOrdersCount: action.payload,
        },
      };
    // pagination order notifications
    case actionTypes.FIRESTORE_SET_TOTAL_ORDERS_NOTIFICATIONS_COUNT:
      return {
        ...state,
        pagination: {
          ...state.pagination,
          allOrderNotifications: action.payload,
        },
      };

    default:
      return state;
  }
};

export default orderReducer;
